<template>
  <video :src="src" type="video/mp4" autoplay loop muted playsinline></video>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  props: {
    desktopSrc: {
      type: String,
      required: true,
    },
    mobileSrc: {
      type: String,
      default: null,
    },
    mobileMaxWidth: {
      type: Number,
      default: 1023,
    },
  },

  data() {
    return {
      singleVideo: !this.mobileSrc,
      size: null,
    };
  },

  created() {
    // This is defined here rather than in methods because otherwise the
    // debounced function will only be called on the last instance of the
    // component, rather than on all of them. We also need to bind the context
    // to `this` for it to work as expected.
    this.updateScreenSize = debounce(
      function() {
        this.size = window.innerWidth <= this.mobileMaxWidth ? 'mobile' : 'desktop';
      }.bind(this),
      100
    );

    if (!this.singleVideo) {
      window.addEventListener('resize', this.updateScreenSize);
    }

    this.updateScreenSize();
  },

  computed: {
    src() {
      if (this.singleVideo) {
        return this.desktopSrc;
      }

      if (this.size === 'mobile') {
        return this.mobileSrc;
      }

      if (this.size === 'desktop') {
        return this.desktopSrc;
      }

      // Return null so that we don't accidentally load one and then the other
      // on page load.
      return null;
    },
  },
};
</script>
